// extracted by mini-css-extract-plugin
module.exports = {"container":"content_text_small_size-module--container--3lW4Z"};